import React from 'react';
import './questionStyles.css';

/*
    props : {
        questions : string[],
        round: Number
    }
 */
export const Question = (props) =>{
    return (
        <div className="question-container">
        <h1 className="question"> {props.questions[props.round]} </h1>
        </div>
    )
}